import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import DemoSection from './components/DemoSection';
import SocialProof from './components/SocialProof';
import Pricing from './components/Pricing';
import Integrations from './components/Integrations';
import CTA from './components/CTA';
import Footer from './components/Footer';
import GetStartedPage from './pages/GetStartedPage';
import './index.css';
import DarkProblemSection from './components/ProblemSection';
import EnginesSection from './components/EnginesSection';
import RoadmapSection from './components/RoadmapSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import HDataStatsSection from './components/HDataStatsSection';

// Home Page Component
const HomePage = () => {
  useEffect(() => {
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.fade-up, .fade-left, .fade-right, .scale-in').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar />
       <main>
        {/* Home Section */}

        <div id="home">
          <Hero />
          {/* <HDataStatsSection/> */}
          <DarkProblemSection/>
          <EnginesSection/>
        </div>
        
        {/* Features Section */}
        <div id="features">
          <Features />
          <RoadmapSection/>
        </div>
        
        {/* Solutions Section - Using DemoSection as Solutions content */}
        <div id="solutions">
          <DemoSection />
          <AboutSection/>
        </div>
        
        {/* Pricing Section */}
        {/* <div id="pricing">
          <Pricing />
        </div>
         */}
        {/* Resources Section - Combining Social Proof and Integrations */}
        <div id="resources">
          {/* <SocialProof /> */}
          <Integrations />
        </div>
        
        {/* CTA Section */}
        <FAQSection/>
        <CTA />
        <Footer />
      </main>
    </>
  );
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/get-started" element={<GetStartedPage />} />
      </Routes>
    </Router>
  );
}

export default App;